import { ApolloProvider } from '@apollo/client';
import { dark, light } from '@servicetitan/anvil-themes';
import {
  ThemeProvider,
  usePrefersColorScheme,
} from '@servicetitan/design-system';

import modules from '../modules';
import DiagnosticsProvider from '../modules/DiagnosticsModule/DiagnosticsProvider';
import appManager from './appManager';
import Router from './Router';
import { getClient } from '@api/client';
import { useMemo } from 'react';
import ToastsGroup from '@modules/ToastModule/components/ToastsGroup';
import SoftPhoneLoader from '@modules/SoftPhoneModule/components/SoftPhoneLoader';
import { FeatureFlagProvider } from '@modules/FeatureFlagModule';
import BugReportProvider from '@components/BugReportProvider/BugReportProvider';

appManager.start(modules);

function App() {
  const { theme } = usePrefersColorScheme(light, dark);
  const client = useMemo(() => getClient(), []);

  return (
    <BugReportProvider>
      <FeatureFlagProvider>
        <ApolloProvider client={client}>
          <ThemeProvider theme={theme}>
            <DiagnosticsProvider>
              <Router />
              <ToastsGroup />
              <SoftPhoneLoader />
            </DiagnosticsProvider>
          </ThemeProvider>
        </ApolloProvider>
      </FeatureFlagProvider>
    </BugReportProvider>
  );
}

export default App;
